
import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { deleteEvent } from "../services/apiEvents.js";

dayjs.extend(utc);

function AdminActions() {
    const [isDeleting, setIsDeleting] = useState(false);
    const [deletionLog, setDeletionLog] = useState("");
    const queryClient = useQueryClient();

    const handleDeleteExpiredNonRecurringEvents = async () => {
        if (
            !window.confirm(
                "Are you sure you want to delete all non-recurring events with start dates before now? This action cannot be undone."
            )
        ) {
            return;
        }

        setIsDeleting(true);
        setDeletionLog("");

        try {
            // Get all events from the cache
            const cachedEvents = queryClient.getQueryData(["events"]);

            if (!cachedEvents || cachedEvents.length === 0) {
                const msg =
                    "No events found in cache. Please load events first.";
                setDeletionLog(msg);
                setIsDeleting(false);
                return;
            }

            const now = dayjs.utc();
            const eventsToDelete = cachedEvents.filter((event) => {
                // Check if recurrence field is null or empty
                const hasNoRecurrence =
                    !event.recurrence || event.recurrence.trim() === "";

                // Check if start date is before now
                const startDate = dayjs.utc(event.startDatetime);
                const isExpired = startDate.isBefore(now);

                return hasNoRecurrence && isExpired;
            });

            if (eventsToDelete.length === 0) {
                const msg =
                    "No non-recurring events with past start dates found to delete.";
                setDeletionLog(msg);
                setIsDeleting(false);
                return;
            }

            let logText = `Found ${eventsToDelete.length} event(s) to delete:\n\n`;

            // Delete all matching events
            let deletedCount = 0;
            let failedCount = 0;

            for (const event of eventsToDelete) {
                try {
                    await deleteEvent(event.id);
                    deletedCount++;
                    logText += `✓ Deleted: ${event.name} (${event.id})\n`;
                } catch (error) {
                    console.error(`Failed to delete event ${event.id}:`, error);
                    failedCount++;
                    logText += `✗ Failed: ${event.name} (${event.id}) - ${error.message}\n`;
                }
            }

            // Invalidate and refetch events
            await queryClient.invalidateQueries({
                queryKey: ["events"],
            });

            logText += `\n${deletedCount} event(s) deleted successfully`;
            if (failedCount > 0) {
                logText += `, ${failedCount} failed`;
            }
            logText += ".";

            setDeletionLog(logText);
        } catch (error) {
            console.error("Error deleting expired events:", error);
            setDeletionLog(
                `Error: ${error.message || "An unexpected error occurred"}`
            );
        } finally {
            setIsDeleting(false);
        }
    };

    return (
        <div className="w-full max-w-3xl mx-auto space-y-6 p-4">
            <h1 className="text-2xl font-bold">Admin Actions</h1>

        </div>
    );
}

export default AdminActions;